import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from '../../../common/store/generic.selectors';
import {
  ContractTerminationReasonModel,
  contractTerminationReasonFeatureKey,
} from './types';
import { IContractTerminationReasonState } from './contract-termination-reason.reducer';

const contractTerminationReasonFeatureState =
  createFeatureSelector<IContractTerminationReasonState>(
    contractTerminationReasonFeatureKey,
  );

export const contractTerminationReasonSelectors = {
  getById: createApiCallSelectors<
    ContractTerminationReasonModel,
    IContractTerminationReasonState
  >(contractTerminationReasonFeatureState, 'getById'),

  createInstance: createApiCallSelectors<
    ContractTerminationReasonModel,
    IContractTerminationReasonState
  >(contractTerminationReasonFeatureState, 'createInstance'),

  add: createApiCallSelectors<
    ContractTerminationReasonModel,
    IContractTerminationReasonState
  >(contractTerminationReasonFeatureState, 'add'),

  update: createApiCallSelectors<
    ContractTerminationReasonModel,
    IContractTerminationReasonState
  >(contractTerminationReasonFeatureState, 'update'),
};
